import { styled } from '@clickcease/cc-client-components-lib'

export const FlexCentered = styled('div', {
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: '$12',
})

export const ProtectedPcImg = styled('img', {
  width: '190px',
  height: '170px',
  marginBlock: '$12',
})
